import { DpContainer } from '@/components/blocks/DpContainer';
import { Box, Modal, Skeleton } from '@mui/material';
import { OutfitFooter } from '@/components/blocks/ModalOutfits/parts/OutfitItem/parts/OutfitFooter';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import { OutfitList } from '@/components/blocks/ModalOutfits/parts/OutfitList';
import { ModalOutfitsContainerInner } from '@/components/blocks/ModalOutfits/styles/main';
import { OutfitImage } from '@/components/blocks/ModalOutfits/parts/OutfitImage';
import { OutfitHeader } from '@/components/blocks/ModalOutfits/parts/OutfitHeader';
import { OutfitTitle } from '@/components/blocks/ModalOutfits/parts/OutfitTitle';
import { ModalOutfitsProvider } from '@/components/blocks/ModalOutfits/parts/OutfitsProvider';
import { useOutfits } from '@/data/Content/Outfits';
import { useLockBodyScroll } from '@/utils/lockBodyScroll';

interface ModalOutfitsProps {
	image: string;
	part_numbers: string[];
	onClose: () => void;
}

export const ModalOutfits: React.FC<ModalOutfitsProps> = ({ image, part_numbers, onClose }) => {
	const isMobile = useIsMobile();
	const outfits = useOutfits({ partNumbers: part_numbers });

	const isLoadingData = outfits.isLoadingProducts || outfits.isLoadingAvailability;

	useLockBodyScroll(true);

	return (
		<ModalOutfitsProvider value={{ isMobile, onClose, ...outfits }}>
			<Modal
				open
				sx={{ padding: 0 }}
				disableScrollLock
				onClose={onClose}
				slotProps={{
					root: {
						sx: {
							zIndex: { xs: 9999, md: undefined },
						},
					} as any,
				}}
			>
				<Box
					sx={{
						width: '100vw',
						height: '100dvh',
						display: 'flex',
						alignItems: { xs: 'auto', md: 'center' },
						justifyContent: { xs: 'auto', md: 'center' },
					}}
				>
					<DpContainer
						withoutmargin
						framesx={{ backgroundColor: { xs: 'white', md: 'transparent' } }}
						sx={ModalOutfitsContainerInner}
					>
						<OutfitHeader />
						{isLoadingData ? (
							<Skeleton
								variant="rectangular"
								sx={{
									width: '100%',
									height: isMobile ? '100%' : '414px',
								}}
							/>
						) : (
							<>
								{isMobile ? (
									<>
										<OutfitImage image={image} />
										<Box sx={{ flex: 1, overflowY: 'auto', paddingBottom: '10px' }}>
											<OutfitList />
										</Box>
										<OutfitFooter />
									</>
								) : (
									<Box
										sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px', flex: 1 }}
									>
										<Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
											<OutfitImage image={image} />
											<OutfitFooter />
										</Box>
										<Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
											<OutfitTitle />
											<Box sx={{ flex: 1, overflowY: 'auto', maxHeight: '70vh' }}>
												<OutfitList />
											</Box>
										</Box>
									</Box>
								)}
							</>
						)}
					</DpContainer>
				</Box>
			</Modal>
		</ModalOutfitsProvider>
	);
};
